import { render } from "./EmailModal.vue?vue&type=template&id=48410438&scoped=true"
import script from "./EmailModal.vue?vue&type=script&lang=js"
export * from "./EmailModal.vue?vue&type=script&lang=js"

import "./EmailModal.vue?vue&type=style&index=0&id=48410438&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48410438"]])

export default __exports__